/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { DeviceOrgTreeDto } from './device-org-tree-dto';
import { UserOrgTreeDto } from './user-org-tree-dto';
/**
 *
 *
 * @export
 * @interface OrgTreeDto
 */
export interface OrgTreeDto {
  /**
   * @type {string}
   * @memberof OrgTreeDto
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  id: string;

  /**
   * @type {string}
   * @memberof OrgTreeDto
   * @example EMEA Division
   */
  name: string;

  /**
   * @type {string}
   * @memberof OrgTreeDto
   * @example clinic
   */
  organization_role: OrgTreeDtoOrganizationRoleEnum;

  /**
   * @type {number}
   * @memberof OrgTreeDto
   * @example 530
   */
  patients: number;

  /**
   * @type {Array<DeviceOrgTreeDto>}
   * @memberof OrgTreeDto
   */
  devices: Array<DeviceOrgTreeDto>;

  /**
   * @type {Array<UserOrgTreeDto>}
   * @memberof OrgTreeDto
   */
  users: Array<UserOrgTreeDto>;

  /**
   * Email of the creator user
   *
   * @type {string}
   * @memberof OrgTreeDto
   * @example alice@example.com
   */
  creator?: string;

  /**
   * Nested child organizations
   *
   * @type {Array<OrgTreeDto>}
   * @memberof OrgTreeDto
   */
  children?: Array<OrgTreeDto>;
}

/**
 * @export
 * @enum {string}
 */
export enum OrgTreeDtoOrganizationRoleEnum {
  Personal = 'personal',
  Clinic = 'clinic',
  Maintenance = 'maintenance',
  Marsi = 'marsi',
  Tester = 'tester',
  Commercial = 'commercial',
  Distributor = 'distributor',
  SpecialistClinic = 'specialist_clinic',
}
